import type { ReactNode } from 'react';

/**
 * Retângulo flutuante do login: cartão centralizado sobre o
 * `<AuroraBackground />`, não a tela full-bleed de antes.
 *
 * Sombra empilhada (`shadow-auth-profundidade`) + borda translúcida +
 * `backdrop-blur-xl` sobre `bg-auth-superficie/[0.035]` — vidro fosco, não
 * cartão opaco. Entrada única (fade + translate-y-2, 400ms): `animate-auth-entrada`
 * não repete sozinha, e `prefers-reduced-motion`/`[data-movimento='reduzido']`
 * já zeram a duração pra quem pediu menos movimento (ver `estilos.css`).
 */
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div
      className={[
        // `min-h` menor e teto em `100dvh`: o cartao nao pode passar da tela.
        // `dvh` e nao `vh` porque no celular a barra do navegador some e volta,
        // e `vh` mede a tela SEM ela — o rodape ficava cortado.
        'animate-auth-entrada relative w-full max-w-4xl overflow-hidden',
        'min-h-[440px] max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)]',
        'rounded-auth-card border border-auth-borda/8',
        'bg-auth-superficie/[0.035] shadow-auth-profundidade backdrop-blur-xl',
      ].join(' ')}
    >
      <div className="relative z-10 grid h-full grid-cols-1 overflow-y-auto md:grid-cols-[1.15fr_1fr] md:overflow-visible">
        {children}
      </div>
    </div>
  );
}
